import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  MoreVertical,
  Eye,
  Edit,
  UserPlus,
  Flag,
  Mail,
  CheckCircle,
  XCircle,
  Package,
  FileText,
} from 'lucide-react';
import type { AuditException } from '@/types/asset-audit';

interface ExceptionCardMenuProps {
  exception: AuditException;
  onViewDetails: () => void;
  onEdit: () => void;
  onAssign: () => void;
  onChangePriority: () => void;
  onContactAuditor: () => void;
  onResolve: () => void;
  onDismiss: () => void;
  onViewAsset: () => void;
  onViewAudit: () => void;
}

export function ExceptionCardMenu({
  onViewDetails,
  onEdit,
  onAssign,
  onChangePriority,
  onContactAuditor,
  onResolve,
  onDismiss,
  onViewAsset,
  onViewAudit,
}: Readonly<ExceptionCardMenuProps>) {
  const handleClick = (e: React.MouseEvent, handler: () => void) => {
    e.stopPropagation();
    handler();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onClick={(e) => handleClick(e, onViewDetails)}>
          <Eye className="mr-2 h-4 w-4" />
          View Details
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => handleClick(e, onEdit)}>
          <Edit className="mr-2 h-4 w-4" />
          Edit Exception
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={(e) => handleClick(e, onAssign)}>
          <UserPlus className="mr-2 h-4 w-4" />
          Assign to User
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => handleClick(e, onChangePriority)}>
          <Flag className="mr-2 h-4 w-4" />
          Change Priority
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={(e) => handleClick(e, onContactAuditor)}>
          <Mail className="mr-2 h-4 w-4" />
          Contact Auditor
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => handleClick(e, onResolve)}>
          <CheckCircle className="mr-2 h-4 w-4" />
          Resolve
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => handleClick(e, onDismiss)}>
          <XCircle className="mr-2 h-4 w-4" />
          Dismiss
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={(e) => handleClick(e, onViewAsset)}>
          <Package className="mr-2 h-4 w-4" />
          View Asset
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => handleClick(e, onViewAudit)}>
          <FileText className="mr-2 h-4 w-4" />
          View Audit
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
